"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module adaptive-expressions
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Stack implements of MemoryInterface.
 * Memory variables have a hierarchical relationship.
 */
class StackedMemory extends Array {
    static wrap(memory) {
        if (memory instanceof StackedMemory) {
            return memory;
        }
        else {
            const stackedMemory = new StackedMemory();
            stackedMemory.push(memory);
            return stackedMemory;
        }
    }
    getValue(path) {
        if (this.length === 0) {
            return undefined;
        }
        else {
            for (const memory of Array.from(this).reverse()) {
                if (memory.getValue(path) !== undefined) {
                    return memory.getValue(path);
                }
            }
            return undefined;
        }
    }
    setValue(_path, _value) {
        throw new Error(`Can't set value to ${_path}, stacked memory is read-only`);
    }
    version() {
        return '0';
    }
}
exports.StackedMemory = StackedMemory;
//# sourceMappingURL=stackedMemory.js.map